import HistoryView from "./HistoryView.vue"

const base = "/history"

export default [
    {
        path: base,
        name: "historyview",
        component: HistoryView
    }
]